import React from "react";

export default function Loader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B0B0E] gap-4">
      <div className="w-12 h-12 rounded-full border-2 border-[#222230] border-t-[#FF5500] animate-spin" />
      <p className="text-xs font-mono uppercase tracking-widest text-[#68687B]">GET UP FIT</p>
    </div>
  );
}
